"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const material_1 = require("@mui/material");
const Close_1 = __importDefault(require("@mui/icons-material/Close"));
const react_cookie_1 = require("react-cookie");
const Layers_1 = __importDefault(require("@mui/icons-material/Layers"));
const shared_1 = require("../shared");
const shared_2 = require("../shared");
const AddSubscription = ({ open, onClose, userData = null, isFromUser = false, isExtend = false }) => {
    const [ConfirmDialogOpen, setConfirmDialogOpen] = react_1.default.useState(false);
    const [PaymentDialogOpen, setpaymentDialogOpen] = react_1.default.useState(false);
    const [subscriptionList, setSubscriptionList] = react_1.default.useState([]);
    const [planDetails, setPlanDetails] = react_1.default.useState(null);
    const [alertOpen, setAlertOpen] = react_1.default.useState(false);
    const [planId, setPlanId] = react_1.default.useState(0);
    const isEmptyOrSpaces = (value) => {
        return value === undefined || value === null || value === '';
    };
    (0, react_1.useEffect)(() => {
        populateSession();
    }, []);
    const populateSession = async (onLoad) => {
        try {
            const isAutoRenewal = isFromUser;
            // const query = !isAutoRenewal
            //   ? `subscriptions?filters[IsAutoRenewal]=false&sort=displayOrder:asc`
            //   : `subscriptions?sort=displayOrder:asc`;
            const query = `subscriptions?sort=displayOrder:asc`;
            const data = await (0, shared_2.getStrapiData)(query);
            if (data.length > 0) {
                setSubscriptionList(data || []);
            }
        }
        catch (error) { }
    };
    console.log('subscriptionList', subscriptionList);
    function calculateEndDate(days) {
        let startDate = new Date();
        let endDate = new Date(startDate);
        endDate.setDate(startDate.getDate() + days);
        return endDate;
    }
    const handleSubscribeWithPayment = async (planId) => {
        const cookies = new react_cookie_1.Cookies();
        const domain = (0, shared_2.getDomain)();
        let redirect_url = await (0, shared_2.getMainUrl)();
        let redirect_url_payment = redirect_url + `/makePayment`;
        cookies.remove('desmos_subscription_id', domain);
        cookies.remove('payment_source_from', domain);
        cookies.remove('payment_by', domain);
        cookies.remove('payment_for', domain);
        cookies.set('desmos_subscription_id', planId, domain);
        if (!isExtend) {
            cookies.set('payment_source_from', 'desmos_subscription', domain);
        }
        else {
            cookies.set('payment_source_from', 'desmos_subscription_extension', domain);
        }
        cookies.set('payment_by', 'admin', domain);
        cookies.set('payment_for', userData === null || userData === void 0 ? void 0 : userData.id, domain);
        window.location.replace(redirect_url_payment);
    };
    function addDaysToDate(dateString, days, isEndDate) {
        const date = new Date(dateString);
        date.setDate(date.getDate() + days);
        if (isEndDate) {
            date.setHours(23, 59, 59, 0); // 23:59:59 for end date
        }
        else {
            date.setHours(0, 0, 0, 0); // 00:00:00 for start date
        }
        const offset = date.getTimezoneOffset();
        date.setMinutes(date.getMinutes() - offset);
        return date.toISOString();
    }
    const handleSubscribe = async () => {
        var _a, _b, _c, _d, _e, _f;
        let regUser, existingEndDateString, newStartDateString, newEndDateString;
        const subData = await (0, shared_2.getDesmosSubscribed)(userData === null || userData === void 0 ? void 0 : userData.id, "admin");
        regUser = await (0, shared_2.getUserDataById)(userData === null || userData === void 0 ? void 0 : userData.id);
        if (isExtend) {
            existingEndDateString = (_a = subData === null || subData === void 0 ? void 0 : subData.subscribedData) === null || _a === void 0 ? void 0 : _a.endDate;
            newStartDateString = addDaysToDate(existingEndDateString, 1, false); // Start date
            newEndDateString = addDaysToDate(newStartDateString, planDetails.attributes.NumberOfDays, true); // End date    
        }
        else {
            newStartDateString = new Date();
            newEndDateString = calculateEndDate(planDetails.attributes.NumberOfDays);
        }
        let plan = {
            planId: planDetails.id,
            period: planDetails.attributes.NumberOfDays,
            startDate: newStartDateString,
            endDate: newEndDateString,
            ongoing: true,
            IsAutoRenewal: planDetails.attributes.IsAutoRenewal,
            name: `Desmos - ${(_b = planDetails.attributes.Period) !== null && _b !== void 0 ? _b : ''}`,
            amount: planDetails.attributes.Amount,
            amountSummary: planDetails.attributes.AmountSummary,
        };
        const desmosPlanList = (regUser === null || regUser === void 0 ? void 0 : regUser.subscribedDesmos) || [];
        desmosPlanList.push(plan);
        let body = { subscribedDesmos: desmosPlanList };
        const response = await (0, shared_1.callApi)(`registration/${userData === null || userData === void 0 ? void 0 : userData.id}`, 'PUT', body);
        handleClose();
        handleSnackBarOpen();
        if (response.status === 200 && !isExtend) {
            const mailData = {
                id: userData === null || userData === void 0 ? void 0 : userData.id,
                name: plan.name,
                totalCost: 0,
                startDate: (_c = plan.startDate.toISOString()) === null || _c === void 0 ? void 0 : _c.slice(0, 10),
                endDate: (_d = plan.endDate.toISOString()) === null || _d === void 0 ? void 0 : _d.slice(0, 10),
                IsAutoRenewal: plan.IsAutoRenewal,
            };
            const response = (0, shared_1.callApi)('auth/subscribesuccess', 'POST', mailData);
            setAlertOpen(false);
            onClose();
        }
        else if (isExtend) {
            const mailData = {
                id: userData === null || userData === void 0 ? void 0 : userData.id,
                name: plan.name,
                totalCost: 0,
                startDate: (_e = plan.startDate) === null || _e === void 0 ? void 0 : _e.slice(0, 10),
                endDate: (_f = plan.endDate) === null || _f === void 0 ? void 0 : _f.slice(0, 10),
                IsAutoRenewal: plan.IsAutoRenewal,
            };
            const response = (0, shared_1.callApi)('auth/subscribesuccess', 'POST', mailData);
            setAlertOpen(false);
            onClose();
            paymenthandleClose();
        }
    };
    const handleSubscribePayment = (planId) => async (event) => {
        console.log('planID', planId);
        const cookies = new react_cookie_1.Cookies();
        const domain = (0, shared_2.getDomain)();
        let redirect_url = await (0, shared_2.getMainUrl)();
        let redirect_url_payment = redirect_url + `/makePayment`;
        cookies.remove('desmos_subscription_id');
        cookies.remove('payment_source_from');
        cookies.set('desmos_subscription_id', planId, domain);
        cookies.set('payment_source_from', 'desmos_subscription_extension', domain);
        window.location.replace(redirect_url_payment);
    };
    const handlePayment = (id) => {
        var _a;
        setPlanId(id === null || id === void 0 ? void 0 : id.id);
        if (!((_a = id === null || id === void 0 ? void 0 : id.attributes) === null || _a === void 0 ? void 0 : _a.IsAutoRenewal)) {
            setpaymentDialogOpen(true);
            setPlanDetails(id);
        }
        else {
            handleSubscribeWithPayment(id === null || id === void 0 ? void 0 : id.id);
        }
    };
    const handleClickOpen = () => {
        setConfirmDialogOpen(true);
    };
    const handleClose = () => {
        setPlanDetails(null);
        setConfirmDialogOpen(false);
    };
    const paymenthandleClose = () => {
        setPlanDetails(null);
        setpaymentDialogOpen(false);
    };
    const handleSnackBarOpen = () => {
        setAlertOpen(true);
    };
    const handleSnackBarClose = () => {
        setAlertOpen(false);
    };
    const handlePaymentSub = () => {
        handleSubscribeWithPayment(planId);
    };
    return ((0, jsx_runtime_1.jsxs)(material_1.Dialog, Object.assign({ open: open, onClose: onClose, maxWidth: "sm", fullWidth: true }, { children: [(0, jsx_runtime_1.jsxs)(material_1.DialogTitle, { children: [isFromUser ? 'Extend Plan' : 'Subscriptions', (0, jsx_runtime_1.jsx)(material_1.IconButton, Object.assign({ "aria-label": "close", onClick: onClose, sx: { position: "absolute", right: 8, top: 8 } }, { children: (0, jsx_runtime_1.jsx)(Close_1.default, {}) }))] }), (0, jsx_runtime_1.jsx)(material_1.DialogContent, { children: (subscriptionList || []).map((item, i) => {
                    var _a, _b, _c;
                    return ((0, jsx_runtime_1.jsx)(material_1.Card, Object.assign({ variant: "outlined", sx: { mb: 3, bgcolor: "primary.50" } }, { children: (0, jsx_runtime_1.jsxs)(material_1.CardContent, Object.assign({ sx: { display: "flex", alignItems: "center" } }, { children: [(0, jsx_runtime_1.jsx)(Layers_1.default, { sx: { mr: 2, color: "primary.main" } }), (0, jsx_runtime_1.jsxs)(material_1.Box, Object.assign({ flexGrow: 1 }, { children: [(0, jsx_runtime_1.jsx)(material_1.Typography, Object.assign({ variant: "subtitle1" }, { children: (_a = item === null || item === void 0 ? void 0 : item.attributes) === null || _a === void 0 ? void 0 : _a.AmountSummary })), (0, jsx_runtime_1.jsxs)(material_1.Typography, Object.assign({ variant: "body2", color: "text.secondary" }, { children: [(_b = item === null || item === void 0 ? void 0 : item.attributes) === null || _b === void 0 ? void 0 : _b.Period, " ", (_c = item === null || item === void 0 ? void 0 : item.attributes) === null || _c === void 0 ? void 0 : _c.Description] }))] })), isFromUser ? ((0, jsx_runtime_1.jsx)(material_1.Button, Object.assign({ onClick: handleSubscribePayment(item === null || item === void 0 ? void 0 : item.id) }, { children: "Extend" }))) : ((0, jsx_runtime_1.jsx)(material_1.Button, Object.assign({ onClick: async () => { var _a; return ((_a = item === null || item === void 0 ? void 0 : item.attributes) === null || _a === void 0 ? void 0 : _a.IsAutoRenewal) ? handleSubscribeWithPayment(item === null || item === void 0 ? void 0 : item.id) : handlePayment(item); } }, { children: "Subscribe" })))] })) })));
                }) }), (0, jsx_runtime_1.jsxs)(material_1.Dialog, Object.assign({ open: ConfirmDialogOpen, onClose: handleClose, "aria-labelledby": "alert-dialog-title", "aria-describedby": "alert-dialog-description" }, { children: [(0, jsx_runtime_1.jsx)(material_1.DialogTitle, Object.assign({ id: "alert-dialog-title" }, { children: "Are you sure you want to proceed further?" })), (0, jsx_runtime_1.jsxs)(material_1.DialogActions, { children: [(0, jsx_runtime_1.jsx)(material_1.Button, Object.assign({ onClick: handleClose }, { children: "No" })), (0, jsx_runtime_1.jsx)(material_1.Button, Object.assign({ onClick: () => handleSubscribe(), autoFocus: true }, { children: "Yes" }))] })] })), (0, jsx_runtime_1.jsxs)(material_1.Dialog, Object.assign({ open: PaymentDialogOpen, onClose: paymenthandleClose, "aria-labelledby": "payment-dialog-title", "aria-describedby": "payment-dialog-description" }, { children: [(0, jsx_runtime_1.jsx)(material_1.DialogTitle, Object.assign({ id: "payment-dialog-title" }, { children: "Select payment type to proceed further?" })), (0, jsx_runtime_1.jsxs)(material_1.DialogActions, { children: [(0, jsx_runtime_1.jsx)(material_1.Button, Object.assign({ onClick: () => handlePaymentSub() }, { children: "Payment" })), (0, jsx_runtime_1.jsx)(material_1.Button, Object.assign({ onClick: () => handleSubscribe(), autoFocus: true }, { children: "Non-Payment" }))] })] })), (0, jsx_runtime_1.jsx)(material_1.Snackbar, Object.assign({ autoHideDuration: 6000, onClose: handleSnackBarClose, anchorOrigin: { vertical: 'bottom', horizontal: 'center' }, open: alertOpen }, { children: (0, jsx_runtime_1.jsx)(material_1.Alert, Object.assign({ onClose: handleSnackBarClose, severity: 'warning', variant: 'filled', sx: { width: '100%' } }, { children: "Subscription Successful!!!" })) }))] })));
};
exports.default = AddSubscription;
